import axios from "axios"

export default {
    namespaced: true,
    state: {
        statistic: [],
        filters: localStorage.getItem('statFilters') ? JSON.parse(localStorage.getItem('statFilters')) : {
            date: [],
            agents: [],
            sources: [],
            types: []
        }
    },
    mutations: {
        SET_STATISTIC(state, statistic) {
            state.statistic = statistic;
        },
        SET_DATE_FILTER(state, date) {
            state.filters.date = date;
            localStorage.setItem('statFilters', JSON.stringify(state.filters));
        },
        SET_TYPE_FILTER(state, types) {
            state.filters.types = [];

            types.forEach(t => {
                state.filters.types.push(t);
            });

            localStorage.setItem('statFilters', JSON.stringify(state.filters));
        },
        SET_SOURCE_FILTER(state, sources) {
            state.filters.sources = [];

            sources.forEach(s => {
                state.filters.sources.push(s);
            });

            localStorage.setItem('statFilters', JSON.stringify(state.filters));
        },
        SET_AGENT_FILTER(state, agents) {
            state.filters.agents = [];

            agents.forEach(a => {
                state.filters.agents.push(a);
            });
            localStorage.setItem('statFilters', JSON.stringify(state.filters));
        },
    },
    getters: {
        statistic: state => state.statistic,
        filters: state => state.filters
    },
    actions: {
        loadStatistic({ commit, state }) {
            axios.post("/statistic", { filters: state.filters}).then((res) => commit("SET_STATISTIC", res.data.statistic)).catch(err => console.log(err));
        }
    },
}

